import React from "react";
import { 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  FormHelperText 
} from "@mui/material";
import { Category } from "../types/productTypes";

interface Props {
  categories: Category[];
  value: string;
  onChange: (val: string) => void;
}

const CategorySelect: React.FC<Props> = ({ categories, value, onChange }) => {
  const isError = !value;

  return (
    <FormControl 
      fullWidth 
     
    >
      <InputLabel 
        id="category-select-label"
      >
        Category type <span style={{ color: "red" }}>*</span>
      </InputLabel>
      <Select
        labelId="category-select-label"
        id="categoryId"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        label="Category type *"
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 1, 
              maxHeight: 300 
            }
          }
        }}
      >
        <MenuItem value="" disabled>
          Select category *
        </MenuItem>
        {categories.map((c) => (
          <MenuItem key={c._id.$oid} value={c._id.$oid}>
            {c.CategoryName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CategorySelect;